import { render, staticRenderFns } from "./PromoBox.vue?vue&type=template&id=c130086a&scoped=true"
import script from "./PromoBox.vue?vue&type=script&lang=js"
export * from "./PromoBox.vue?vue&type=script&lang=js"
import style0 from "./PromoBox.vue?vue&type=style&index=0&id=c130086a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c130086a",
  null
  
)

export default component.exports